import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Lock } from "iconsax-react";
import { useTranslation } from "react-i18next";

import { Link } from "@/components/Atoms";
import { SefanoButton } from "@/components/Molecules";
import * as styles from "./SettingsRestrictedState.styles";

type SettingsRestrictedStateProps = {
  roleLabel: string;
};

export function SettingsRestrictedState({ roleLabel }: SettingsRestrictedStateProps) {
  const { t } = useTranslation("settings");
  const theme = useTheme();

  return (
    <>
      <Box sx={styles.root}>
        <Box sx={styles.iconWrap}>
          <Lock size={52} variant="Bold" color={theme.palette.text.secondary} />
        </Box>
        <Typography sx={styles.title}>{t("restricted.title")}</Typography>
        <Typography sx={styles.description}>
          {t("restricted.description", { role: t(roleLabel) })}
        </Typography>
        <Box sx={styles.actionWrap}>
          <Link to="/orders">
            <SefanoButton intent="secondary">{t("restricted.backToOrders")}</SefanoButton>
          </Link>
        </Box>
      </Box>

      <Box sx={styles.mobileRoot}>
        <Box sx={styles.iconWrap}>
          <Lock size={40} variant="Bold" color={theme.palette.text.secondary} />
        </Box>
        <Typography sx={styles.title}>{t("restricted.mobileTitle")}</Typography>
        <Typography sx={styles.description}>
          {t("restricted.mobileDescription", { role: t(roleLabel) })}
        </Typography>
        <Box sx={styles.actionWrap}>
          <Link to="/orders">
            <SefanoButton intent="secondary">{t("restricted.backToOrders")}</SefanoButton>
          </Link>
        </Box>
      </Box>
    </>
  );
}
